export const STYLE_OPTIONS = [
  {
    name: "Icon",
    prompt: "simplified iconic symbols with unified line weight",
    image: "https://storage.googleapis.com/video-agent-assets-public/generated_assets/images/styles/Icon.jpg",
  },
  {
    name: "Vector Graphic",
    prompt: "2D flat vector with smooth gradients and strokes",
    image: "https://storage.googleapis.com/video-agent-assets-public/generated_assets/images/styles/2D_flat_vector.jpg",
  },
  {
    name: "3D Isometric",
    prompt: "isometric 3D with consistent dimensional perspective",
    image: "https://storage.googleapis.com/video-agent-assets-public/generated_assets/images/styles/3D_isometric.jpg",
  },
  {
    name: "Character Animation",
    prompt: "friendly cartoon characters with expressive faces",
    image: "https://storage.googleapis.com/video-agent-assets-public/generated_assets/images/styles/character_animations.jpg",
  },
  {
    name: "Pixel Art",
    prompt: "8-bit pixel art with chunky blocks",
    image: "https://storage.googleapis.com/video-agent-assets-public/generated_assets/images/styles/pixel_art.jpg",
  },
  {
    name: "Risograph Print",
    prompt: "risograph with misaligned layers and dots",
    image: "https://storage.googleapis.com/video-agent-assets-public/generated_assets/images/styles/risograph.jpg",
  },
  {
    name: "Retrofuturistic",
    prompt: "1950s retrofuture with atomic age elements",
    image: "https://storage.googleapis.com/video-agent-assets-public/generated_assets/images/styles/retro.jpg",
  },
];

// Color palettes array - each palette has 5 colors
export const COLOR_PALETTES = [
  {
    id: "default",
    name: "Default",
    colors: ["#1e40af", "#3b82f6", "#93c5fd", "#dbeafe", "#eff6ff"],
  },
  {
    id: "sunset",
    name: "Sunset",
    colors: ["#b91c1c", "#f59e0b", "#fbbf24", "#fde68a", "#fef3c7"],
  },
  {
    id: "forest",
    name: "Forest",
    colors: ["#064e3b", "#047857", "#10b981", "#6ee7b7", "#d1fae5"],
  },
  {
    id: "ocean",
    name: "Ocean",
    colors: ["#0c4a6e", "#0369a1", "#0ea5e9", "#7dd3fc", "#e0f2fe"],
  },
  {
    id: "monochrome",
    name: "Monochrome",
    colors: ["#18181b", "#3f3f46", "#71717a", "#a1a1aa", "#e4e4e7"],
  },
  {
    id: "oceanBreeze",
    name: "Ocean Breeze",
    colors: ["#1A535C", "#4ECDC4", "#F7FFF7", "#FF6B6B", "#FFE66D"],
  },
  {
    id: "retroWave",
    name: "Retro Wave",
    colors: ["#2B193D", "#9C528B", "#F8C630", "#2BBBD8", "#23F0C7"],
  },
  {
    id: "softPastels",
    name: "Soft Pastels",
    colors: ["#F1E4E8", "#E2F0CB", "#B9CDDA", "#FFC8DD", "#CDB4DB"],
  },
  {
    id: "boldMinimal",
    name: "Bold Minimal",
    colors: ["#F9F9F9", "#F5F5F5", "#000000", "#FF5252", "#FFD166"],
  },
  {
    id: "corporateBlue",
    name: "Corporate Blue",
    colors: ["#003366", "#336699", "#99CCFF", "#FFFFFF", "#CCCCCC"],
  },
  {
    id: "digitalNeon",
    name: "Digital Neon",
    colors: ["#2D00F7", "#6A00F4", "#8900F2", "#BC00DD", "#FF00C8"],
  },
  {
    id: "earthTones",
    name: "Earth Tones",
    colors: ["#582F0E", "#7F4F24", "#936639", "#A68A64", "#B6AD90"],
  },
  {
    id: "candyPop",
    name: "Candy Pop",
    colors: ["#E60965", "#F94892", "#FFA1C9", "#FBE5E5", "#F8F0DF"],
  },
  {
    id: "deepOcean",
    name: "Deep Ocean",
    colors: ["#0A1128", "#001F54", "#034078", "#1282A2", "#FEFCFB"],
  },
  {
    id: "autumnLeaves",
    name: "Autumn Leaves",
    colors: ["#780000", "#C1121F", "#FDF0D5", "#8A5A44", "#003049"],
  },
  {
    id: "techStartup",
    name: "Tech Startup",
    colors: ["#0B0C10", "#1F2833", "#C5C6C7", "#66FCF1", "#45A29E"],
  },
  {
    id: "sunsetVibes",
    name: "Sunset Vibes",
    colors: ["#05386B", "#379683", "#5CDB95", "#EDF5E1", "#F8B195"],
  },
  {
    id: "mintChocolate",
    name: "Mint Chocolate",
    colors: ["#2A0800", "#4E3500", "#5E6600", "#7FB800", "#A4BE7B"],
  },
  {
    id: "berryFrost",
    name: "Berry Frost",
    colors: ["#4A0D67", "#7A1855", "#CD5D67", "#F6E8EA", "#22AED1"],
  },
  {
    id: "urbanModern",
    name: "Urban Modern",
    colors: ["#212529", "#343A40", "#495057", "#6C757D", "#F8F9FA"],
  },
  {
    id: "mediterraneanSummer",
    name: "Mediterranean Summer",
    colors: ["#264653", "#2A9D8F", "#E9C46A", "#F4A261", "#E76F51"],
  },
  {
    id: "purpleRain",
    name: "Purple Rain",
    colors: ["#231942", "#5E548E", "#9F86C0", "#BE95C4", "#E0B1CB"],
  },
  {
    id: "coffeeTones",
    name: "Coffee Tones",
    colors: ["#3E2723", "#4E342E", "#5D4037", "#8D6E63", "#EFEBE9"],
  },
  {
    id: "freshMint",
    name: "Fresh Mint",
    colors: ["#F1FAEE", "#A8DADC", "#457B9D", "#1D3557", "#DEF2C8"],
  },
  {
    id: "darkMode",
    name: "Dark Mode",
    colors: ["#121212", "#1E1E1E", "#292929", "#3D4143", "#ECEFF1"],
  },
  {
    id: "neonLights",
    name: "Neon Lights",
    colors: ["#240046", "#3C096C", "#5A189A", "#7B2CBF", "#FF9E00"],
  },
  {
    id: "modernFarmhouse",
    name: "Modern Farmhouse",
    colors: ["#EEEEEE", "#F8F8F8", "#4A4A4A", "#000000", "#B4B4B4"],
  },
  {
    id: "winterChill",
    name: "Winter Chill",
    colors: ["#9DB5B2", "#DAD7CD", "#94D2BD", "#0A9396", "#005F73"],
  },
  {
    id: "electricPurple",
    name: "Electric Purple",
    colors: ["#10002B", "#240046", "#3C096C", "#5A189A", "#7B2CBF"],
  },
  {
    id: "freshCitrus",
    name: "Fresh Citrus",
    colors: ["#FFB703", "#FB8500", "#219EBC", "#023047", "#8ECAE6"],
  },
  {
    id: "dataViz",
    name: "Data Viz Pro",
    colors: ["#003F5C", "#58508D", "#BC5090", "#FF6361", "#FFA600"],
  },
  {
    id: "ecoGreen",
    name: "Eco Green",
    colors: ["#D8F3DC", "#B7E4C7", "#95D5B2", "#74C69D", "#2D6A4F"],
  },
  {
    id: "dustyRose",
    name: "Dusty Rose",
    colors: ["#E8DFE0", "#D8A7B1", "#B6E2D3", "#8D98A7", "#3A405A"],
  },
  {
    id: "goldenHour",
    name: "Golden Hour",
    colors: ["#FF9F1C", "#FFBF69", "#FFFFFF", "#CBF3F0", "#2EC4B6"],
  },
  {
    id: "techReport",
    name: "Tech Report",
    colors: ["#2B2D42", "#8D99AE", "#EDF2F4", "#EF233C", "#D90429"],
  },
  {
    id: "minimalGray",
    name: "Minimal Gray",
    colors: ["#F8F9FA", "#E9ECEF", "#DEE2E6", "#CED4DA", "#212529"],
  },
  {
    id: "tropicalPunch",
    name: "Tropical Punch",
    colors: ["#5F0F40", "#9A031E", "#FB8B24", "#E36414", "#0F4C5C"],
  },
  {
    id: "lavaLamp",
    name: "Lava Lamp",
    colors: ["#FF0000", "#FF8700", "#FFE400", "#A3DE83", "#00BFFF"],
  },
  {
    id: "glacierBlue",
    name: "Glacier Blue",
    colors: ["#F1FFFA", "#CCFCCB", "#96E6B3", "#54C6EB", "#346299"],
  },
  {
    id: "cherryBlossom",
    name: "Cherry Blossom",
    colors: ["#FFB7C5", "#FFE8E8", "#F9FBF2", "#B1DFB0", "#68C29F"],
  },
  {
    id: "nightSky",
    name: "Night Sky",
    colors: ["#0D1B2A", "#1B263B", "#415A77", "#778DA9", "#E0E1DD"],
  },
  {
    id: "businessInsight",
    name: "Business Insight",
    colors: ["#001219", "#005F73", "#0A9396", "#94D2BD", "#E9D8A6"],
  },
  {
    id: "bloomingGarden",
    name: "Blooming Garden",
    colors: ["#606C38", "#283618", "#FEFAE0", "#DDA15E", "#BC6C25"],
  },
  {
    id: "candyStore",
    name: "Candy Store",
    colors: ["#FFADAD", "#FFD6A5", "#FDFFB6", "#CAFFBF", "#9BF6FF"],
  },
  {
    id: "darkLuxury",
    name: "Dark Luxury",
    colors: ["#0B090A", "#161A1D", "#660708", "#A4161A", "#E5383B"],
  },
  {
    id: "safetyOrange",
    name: "Safety Orange",
    colors: ["#001219", "#005F73", "#0A9396", "#E9D8A6", "#EE9B00"],
  },
  {
    id: "modernScandy",
    name: "Modern Scandy",
    colors: ["#FFFFFF", "#F5F5F5", "#F9BDBD", "#D9D4C5", "#303030"],
  },
  {
    id: "sandyBeach",
    name: "Sandy Beach",
    colors: ["#F2E9E4", "#C9ADA7", "#9A8C98", "#4A4E69", "#22223B"],
  },
  {
    id: "deepSpace",
    name: "Deep Space",
    colors: ["#03071E", "#370617", "#6A040F", "#9D0208", "#DC2F02"],
  },
  {
    id: "softFinance",
    name: "Soft Finance",
    colors: ["#F6F6F6", "#E8E8E8", "#333333", "#990000", "#333C83"],
  },
  {
    id: "coralReef",
    name: "Coral Reef",
    colors: ["#F94144", "#F3722C", "#F8961E", "#F9844A", "#F9C74F"],
  },
  {
    id: "vintagePostcard",
    name: "Vintage Postcard",
    colors: ["#FFCDB2", "#FFB4A2", "#E5989B", "#B5838D", "#6D6875"],
  },
  {
    id: "greenTechnology",
    name: "Green Technology",
    colors: ["#353535", "#3C6E71", "#FFFFFF", "#D9D9D9", "#284B63"],
  },
  {
    id: "purpleHaze",
    name: "Purple Haze",
    colors: ["#10002B", "#240046", "#3C096C", "#5A189A", "#9D4EDD"],
  },
  {
    id: "midnightCoral",
    name: "Midnight Coral",
    colors: ["#1A1A2E", "#16213E", "#0F3460", "#E94560", "#FFFFFF"],
  },
  {
    id: "forestBath",
    name: "Forest Bath",
    colors: ["#081C15", "#1B4332", "#2D6A4F", "#40916C", "#52B788"],
  },
  {
    id: "marketingSuite",
    name: "Marketing Suite",
    colors: ["#0077B6", "#00B4D8", "#90E0EF", "#CAF0F8", "#03045E"],
  },
  {
    id: "royalPastel",
    name: "Royal Pastel",
    colors: ["#F1C0E8", "#CFBAF0", "#A3C4F3", "#90DBF4", "#8EECF5"],
  },
  {
    id: "cityScape",
    name: "City Scape",
    colors: ["#7D8491", "#BFC0C0", "#4F5D75", "#2D3142", "#EF8354"],
  },
  {
    id: "moneyGreen",
    name: "Money Green",
    colors: ["#EDF2F4", "#FFFFFF", "#006400", "#2F4F4F", "#242423"],
  },
  {
    id: "neutralTones",
    name: "Neutral Tones",
    colors: ["#E6E8E6", "#CED0CE", "#9FB1BC", "#5B7D87", "#445E69"],
  },
  {
    id: "techPurple",
    name: "Tech Purple",
    colors: ["#22223B", "#4A4E69", "#9A8C98", "#C9ADA7", "#F2E9E4"],
  },
  {
    id: "fruityPebbles",
    name: "Fruity Pebbles",
    colors: ["#D8E2DC", "#FFE5D9", "#FFCAD4", "#F4ACB7", "#9D8189"],
  },
  {
    id: "classicInfographic",
    name: "Classic Infographic",
    colors: ["#003049", "#D62828", "#F77F00", "#FCBF49", "#EAE2B7"],
  },
  {
    id: "grayscalePlus",
    name: "Grayscale Plus",
    colors: ["#E5E5E5", "#CCCCCC", "#999999", "#666666", "#FF6B6B"],
  },
  {
    id: "energyFlow",
    name: "Energy Flow",
    colors: ["#F72585", "#7209B7", "#3A0CA3", "#4361EE", "#4CC9F0"],
  },
  {
    id: "dataDriven",
    name: "Data Driven",
    colors: ["#0466C8", "#0353A4", "#023E7D", "#002855", "#001845"],
  },
  {
    id: "darkGradient",
    name: "Dark Gradient",
    colors: ["#0D1B2A", "#1B263B", "#415A77", "#778DA9", "#E0E1DD"],
  },
  {
    id: "softGradient",
    name: "Soft Gradient",
    colors: ["#8ecae6", "#219ebc", "#126782", "#023047", "#ffb703"],
  },
  {
    id: "redAlert",
    name: "Red Alert",
    colors: ["#000000", "#14213D", "#FCA311", "#E5E5E5", "#D00000"],
  },
  {
    id: "minimalistInfo",
    name: "Minimalist Info",
    colors: ["#F8F9FA", "#E9ECEF", "#6C757D", "#343A40", "#212529"],
  },
  {
    id: "vividContrast",
    name: "Vivid Contrast",
    colors: ["#0B132B", "#1C2541", "#3A506B", "#5BC0BE", "#FFFFFF"],
  },
  {
    id: "metroStyle",
    name: "Metro Style",
    colors: ["#340068", "#6B0F1A", "#39A9DB", "#F0C808", "#587291"],
  },
  {
    id: "dataJournal",
    name: "Data Journal",
    colors: ["#1A1423", "#372549", "#774C60", "#B75D69", "#EACDC2"],
  },
  {
    id: "vibrantChart",
    name: "Vibrant Chart",
    colors: ["#214F4B", "#1E2F23", "#F2542D", "#F5DFBB", "#127475"],
  },
  {
    id: "businessCasual",
    name: "Business Casual",
    colors: ["#040F16", "#0B4F6C", "#01BAEF", "#B80C09", "#FBFBFF"],
  },
  {
    id: "sunnyDay",
    name: "Sunny Day",
    colors: ["#003049", "#669BBC", "#A5BE00", "#EEE82C", "#F4D35E"],
  },
  {
    id: "pastelStrength",
    name: "Pastel Strength",
    colors: ["#F08080", "#F4978E", "#F8AD9D", "#FBC4AB", "#FFDAB9"],
  },
  {
    id: "corporateTrust",
    name: "Corporate Trust",
    colors: ["#1A535C", "#4ECDC4", "#F7FFF7", "#FF6B6B", "#FFE66D"],
  },
  {
    id: "darkAcademia",
    name: "Dark Academia",
    colors: ["#2F2519", "#604D3C", "#8C7A6B", "#B9A89B", "#E8DFD8"],
  },
  {
    id: "vibrantData",
    name: "Vibrant Data",
    colors: ["#F94144", "#F3722C", "#F8961E", "#F9C74F", "#90BE6D"],
  },
  {
    id: "futuristicBlue",
    name: "Futuristic Blue",
    colors: ["#03045E", "#023E8A", "#0077B6", "#0096C7", "#00B4D8"],
  },
  {
    id: "frostedGlass",
    name: "Frosted Glass",
    colors: ["#E0FBFC", "#C2DFE3", "#9DB4C0", "#5C6B73", "#253237"],
  },
  {
    id: "springAwakening",
    name: "Spring Awakening",
    colors: ["#D8E2DC", "#FFE5D9", "#FFCAD4", "#F4ACB7", "#9D8189"],
  },
  {
    id: "analyticalRed",
    name: "Analytical Red",
    colors: ["#283D3B", "#197278", "#EDDDD4", "#C44536", "#772E25"],
  },
  {
    id: "financialBlue",
    name: "Financial Blue",
    colors: ["#00072D", "#001C55", "#0A2472", "#0E6BA8", "#A6E1FA"],
  },
  {
    id: "neutralModern",
    name: "Neutral Modern",
    colors: ["#EDEDE9", "#D6CCC2", "#F5EBE0", "#E3D5CA", "#D5BDAF"],
  },
  {
    id: "slateNight",
    name: "Slate Night",
    colors: ["#2B2D42", "#8D99AE", "#EDF2F4", "#EF233C", "#D90429"],
  },
  {
    id: "springHarmony",
    name: "Spring Harmony",
    colors: ["#588157", "#3A5A40", "#344E41", "#DAD7CD", "#A3B18A"],
  },
  {
    id: "dataVisBlue",
    name: "DataVis Blue",
    colors: ["#012A4A", "#013A63", "#01497C", "#014F86", "#2A6F97"],
  },
  {
    id: "earthAnalytics",
    name: "Earth Analytics",
    colors: ["#582F0E", "#7F4F24", "#936639", "#A68A64", "#D4C7B0"],
  },
  {
    id: "retroInfograph",
    name: "Retro Infograph",
    colors: ["#264653", "#2A9D8F", "#E9C46A", "#F4A261", "#E76F51"],
  },
  {
    id: "viridis",
    name: "Viridis",
    colors: ["#440154", "#414487", "#2A788E", "#22A884", "#7AD151"],
  },
  {
    id: "magma",
    name: "Magma",
    colors: ["#000004", "#3B0F70", "#8C2981", "#DD4A6A", "#FDC926"],
  },
  {
    id: "inferno",
    name: "Inferno",
    colors: ["#000004", "#320A5A", "#781C6D", "#CF4446", "#FCFFA4"],
  },
  {
    id: "plasma",
    name: "Plasma",
    colors: ["#0D0887", "#5B02A3", "#9A179B", "#DB4478", "#FD9A69"],
  },
  {
    id: "cividis",
    name: "Cividis",
    colors: ["#00204D", "#213D6B", "#555B6C", "#7B7B78", "#A59C74"],
  },
  {
    id: "turbo",
    name: "Turbo",
    colors: ["#30123B", "#4686AA", "#36BCAD", "#BADC53", "#F3F799"],
  },
  {
    id: "twilight",
    name: "Twilight",
    colors: ["#3F2E56", "#C17817", "#F1AB24", "#E9CE81", "#91221A"],
  },
  {
    id: "matplotlibDefault",
    name: "Matplotlib Default",
    colors: ["#1F77B4", "#FF7F0E", "#2CA02C", "#D62728", "#9467BD"],
  },
  {
    id: "tableau10",
    name: "Tableau 10",
    colors: ["#4E79A7", "#F28E2C", "#E15759", "#76B7B2", "#59A14F"],
  },
  {
    id: "powerbi",
    name: "Power BI",
    colors: ["#118DFF", "#12239E", "#6B007B", "#E66C37", "#6B007B"],
  },
  {
    id: "excellike",
    name: "Excel-like",
    colors: ["#4472C4", "#ED7D31", "#A5A5A5", "#FFC000", "#5B9BD5"],
  },
  {
    id: "googleCharts",
    name: "Google Charts",
    colors: ["#3366CC", "#DC3912", "#FF9900", "#109618", "#990099"],
  },
  {
    id: "highchartsDefault",
    name: "Highcharts Default",
    colors: ["#7CB5EC", "#434348", "#90ED7D", "#F7A35C", "#8085E9"],
  },
  {
    id: "echartsDefault",
    name: "ECharts Default",
    colors: ["#5470C6", "#91CC75", "#FAC858", "#EE6666", "#73C0DE"],
  },
];